import React, { FC, useState } from 'react';
import { Row, Spacer, Text, Column } from '@components/1-atoms';
import { AppTemplate } from '@components/4-templates';
import { Slider } from '@components/3-organisms';

import { ForwardedPageProps } from '@lib/constants';
import { withForwardedNavigationParams } from 'react-navigation-props-mapper';

import setTheme from '@lib/theme';

const theme = setTheme('light');

const slides = [
  {
    title: 'Oversee your finances',
    subtitle: 'Advanced insights and document management while on the go',
    image: require("./slides/financial-insights.png")
  },
  {
    title: 'Price and track products right',
    image: require("./slides/item-and-pricing.png")
  },
  {
    title: 'Send pro estimates, invoices*, ...',
    image: require("./slides/document-management.png")
  },
];

const OnboardingSlider: FC<ForwardedPageProps> = ({ navigation, ...props }) => {

    return (
        <AppTemplate hooks={[]}  /* gradiant={theme.gradients.white} */ >
           <Slider
            data={slides} 
            onSkip={() => navigation.navigate( 'EmailLogin' )}
            onDone={() => navigation.navigate( 'EmailLogin' )}
          />
        </AppTemplate>
    );
};

export default withForwardedNavigationParams<ForwardedPageProps>()(OnboardingSlider);